var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-cart';
                    var viewUrl = 'gfx/sprite.svg#view-icon-cart';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };